import { render, staticRenderFns } from "./tag.component.vue?vue&type=template&id=701e50d0&scoped=true"
import script from "./tag.component.vue?vue&type=script&lang=ts"
export * from "./tag.component.vue?vue&type=script&lang=ts"
import style0 from "./tag-edit.style.scss?vue&type=style&index=0&id=701e50d0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e50d0",
  null
  
)

export default component.exports